import { ButtonHTMLAttributes, DetailedHTMLProps, forwardRef } from 'react'

interface IProps extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  theme?: 'primary' | 'grey' | 'danger' | 'grey-outline' | 'lightgreen'
  loading?: boolean
  size?: 'l' | 'm' | 's' | 'xs'
  fullWidth?: boolean
}

export type TButtonProps = IProps

const Button = forwardRef<HTMLButtonElement, TButtonProps>(({ children, theme = 'primary', loading, fullWidth = true, ...props }, ref) => {
  return (
    <button
      {...props}
      ref={ref}
      className={`etba-button ${props.className ?? ''}`}
      data-theme={theme}
      data-loading={loading ? 'true' : 'false'}
      data-size={props.size}
      data-fullwidth={fullWidth ? 'true' : 'false'}
    >
      <span>{children}</span>
    </button>
  )
})

export default Button
